const input = document.getElementById('js-search');
const suggest = document.getElementById('js-result-list');

if ((input && suggest) !== null) {
  const method = input.closest('form').dataset.autoSuggestMethod;
  const xhr = new XMLHttpRequest();

  const delay = (() => {
    let timer = 0;
    return (callback, ms) => {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();

  if (input) {
    input.addEventListener('keyup', () => {
      delay(() => {
        if (input.value.length > 2) {
          let action = input.closest('form').dataset.autoSuggestAction;

          // fix relative path
          if (action.indexOf('/') !== 0) {
            action = `/${action}`;
          }

          action = `${action}&term=${input.value}`;
          xhr.open(method, action, true);
          xhr.onload = () => {
            if (xhr.response.trim().substr(0, 3) === '<li') {
              suggest.innerHTML = xhr.response;
              suggest.classList.add('is--active');
            } else {
              suggest.classList.remove('is--active');
            }
          };
          xhr.send();
        } else {
          suggest.classList.remove('is--active');
        }
      }, 400);
    });
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/result-list.js